import { LanguageSwitcher } from "#/components/i18n/LanguageSwitcher.js";
import type { TranslateFn } from "#/lib/i18n.js";
import { getLocalizedHref, safeLocale } from "./shared.js";

export function FooterBentoConsole({ locale, t }: { locale: string; t: TranslateFn }) {
  const links = [
    { href: "/privacy", label: t("chrome.footer.privacy") },
    { href: "/terms", label: t("chrome.footer.terms") },
    { href: getLocalizedHref(locale, "/accessibility"), label: t("chrome.footer.accessibility") },
    { href: getLocalizedHref(locale, "/docs/user/index"), label: t("chrome.footer.docs") },
  ];
  return (
    <footer
      data-public-chrome="footer"
      className="mt-8 border-t border-[color:var(--color-border-subtle)] bg-[color:var(--color-bg-surface)]"
    >
      <div className="mx-auto flex max-w-[96rem] flex-col gap-3 px-4 py-4 text-sm sm:flex-row sm:items-center sm:justify-between sm:px-6 lg:px-8">
        <nav aria-label={t("chrome.footer.navLabel")} className="flex flex-wrap gap-x-4 gap-y-2">
          {links.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="inline-flex min-h-11 items-center text-[color:var(--color-fg-muted)] no-underline transition-colors duration-150 hover:text-[color:var(--color-fg-default)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[color:var(--color-accent-info)]"
            >
              {link.label}
            </a>
          ))}
        </nav>
        <LanguageSwitcher currentLocale={safeLocale(locale)} variant="footer" t={t} />
      </div>
    </footer>
  );
}
